import { IStuHoSoSinhVienViewModel } from "./../../../model/respone/category/IStuHoSoSinhVienViewModel";
import { IBienLaiThuCreateRequest } from "../../../model/request/bien-lai/IBienLaiThuCreateRequest";
import { IMucThuNhapHocSinhVienSelectRequest } from "../../../model/request/chung-tu-nhap-hoc/IMucThuNhapHocSinhVienSelectRequest";
import { IMucThuNhapHocSinhVienViewModel } from "./../../../model/respone/chung-tu-nhap-hoc/IMucThuNhapHocSinhVienViewModel";

import { IThuPhiNhapHocTab } from "../../../model/request/thu-phi-nhap-hoc/IThuPhiNhapHocTab";
import { IBienLaiThuHinhThucNopViewModel } from "../../../model/respone/chung-tu/IBienLaiThuHinhThucNopViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { IQRCodeResponse } from "../../../model/respone/ngan-hang/IQRCodeResponse";
import { IBienLaiThuUpdateRequest } from "../../../model/request/bien-lai/IBienLaiThuUpdateRequest";
import { IBienLaiThuViewModel } from "../../../model/respone/bien-lai/IBienLaiThu";
export interface IThuPhiNhapHocTabActionTyes<T> {
  request: IMucThuNhapHocSinhVienSelectRequest;
  data: T;
}

export interface IThuPhiNhapHocTabByIdActionTyes<T> {
  id: string;
  data: T;
}

export const eThuPhiNhapHocActionsObj = {
  ADD_NEW_TAB: {} as undefined | IStuHoSoSinhVienViewModel,
  REMOVE_TAB: "",
  UPDATE_TAB_DATA: {} as IThuPhiNhapHocTab,
  CHANGEG_SELECTED_TAB: "",

  ADD_NEW_TAB_BY_ID: "",
  ADD_NEW_TAB_BY_ID_ERROR: "",

  LOAD_MUC_THU_START: {} as IMucThuNhapHocSinhVienSelectRequest,
  LOAD_MUC_THU_SUCCESS: {} as IThuPhiNhapHocTabActionTyes<
    IMucThuNhapHocSinhVienViewModel[]
  >,
  LOAD_MUC_THU_ERROR: {} as IThuPhiNhapHocTabActionTyes<string>,
  CHANGE_MUC_THU_SELECTED_IDs: {} as IThuPhiNhapHocTabActionTyes<number[]>,
  CHANGE_STEP: {} as IThuPhiNhapHocTabActionTyes<number>,
  CHANGE_HINHTHUCNOP: {} as IThuPhiNhapHocTabActionTyes<
    IBienLaiThuHinhThucNopViewModel[]
  >,
  CHANGE_SO_TIEN_THUC_NOP: {} as IThuPhiNhapHocTabActionTyes<number>,
  CHANGE_GHI_CHU_KHOAN: {} as IThuPhiNhapHocTabActionTyes<string>,
  /** Phiếu chi: tích "Điều chỉnh giảm định mức" cho một khoản. */
  CHANGE_DIEU_CHINH_GIAM_DINH_MUC: {} as IThuPhiNhapHocTabActionTyes<boolean>,
  CREATE_BIENLAITHU_START: {} as IBienLaiThuCreateRequest,
  CREATE_BIENLAITHU_SUCCESS: {} as IThuPhiNhapHocTabActionTyes<number>,
  CREATE_BIENLAITHU_ERROR: {} as IThuPhiNhapHocTabActionTyes<string>,

  // Sửa biên lai tại chỗ
  LOAD_EDIT_BIENLAI_START: {} as {
    id_bien_lai: number;
    request: IMucThuNhapHocSinhVienSelectRequest;
  },
  LOAD_EDIT_BIENLAI_SUCCESS: {} as IThuPhiNhapHocTabActionTyes<IBienLaiThuViewModel>,
  LOAD_EDIT_BIENLAI_ERROR: {} as IThuPhiNhapHocTabActionTyes<string>,
  CANCEL_EDIT_BIENLAI: {} as IMucThuNhapHocSinhVienSelectRequest,
  UPDATE_BIENLAITHU_START: {} as IBienLaiThuUpdateRequest,
  UPDATE_BIENLAITHU_SUCCESS: {} as IThuPhiNhapHocTabActionTyes<number>,
  UPDATE_BIENLAITHU_ERROR: {} as IThuPhiNhapHocTabActionTyes<string>,
  // CHANGE_LOAIBIENLAI: {} as IThuPhiNhapHocTabActionTyes<"thu" | "chi">,
  // CHANGE_NAMNHAPHOC: {} as IThuPhiNhapHocTabActionTyes<number>,
  CHANGE_THONGTINBIENLAI: {} as IThuPhiNhapHocTabActionTyes<any>,

  PREVIEW_BIENLAITHU_START: {} as IBienLaiThuCreateRequest,
  PREVIEW_BIENLAITHU_SUCCESS: {} as IThuPhiNhapHocTabActionTyes<string>,
  PREVIEW_BIENLAITHU_ERROR: {} as IThuPhiNhapHocTabActionTyes<string>,
  PREVIEW_BIENLAITHU_CLOSE: {} as IThuPhiNhapHocTabActionTyes<string>,

  UPDATE_QRCODE: {} as IThuPhiNhapHocTabByIdActionTyes<
    IQRCodeResponse | undefined
  >,
  UPDATE_QRCODES: {} as IThuPhiNhapHocTabByIdActionTyes<IQRCodeResponse[]>,
  UPDATE_GENQR_LOADING: {} as IThuPhiNhapHocTabByIdActionTyes<boolean>,
};
export const eThuPhiNhapHocActionIds = generateActionTypeIds(
  eThuPhiNhapHocActionsObj,
  "THU_PHI_NHAP_HOC",
);
export type IThuPhiNhapHocActionTypes = IGenericActionType<
  typeof eThuPhiNhapHocActionsObj,
  "THU_PHI_NHAP_HOC"
>;
